import { useEffect, useMemo } from 'react';

export type ThemeId = 'light' | 'dark' | 'system';
export type ResolvedThemeId = Exclude<ThemeId, 'system'>;

const THEME_STORAGE_KEY = 'theme';

const isThemeId = (value: string | null): value is ThemeId => {
  return value === 'light' || value === 'dark' || value === 'system';
};

const getStoredTheme = (): ThemeId => {
  const theme = localStorage.getItem(THEME_STORAGE_KEY);

  return isThemeId(theme) ? theme : 'system';
};

const getSystemTheme = (): ResolvedThemeId => {
  return window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
};

const resolveTheme = (theme: ThemeId): ResolvedThemeId => {
  return theme === 'system' ? getSystemTheme() : theme;
};

const applyTheme = (theme: ThemeId): void => {
  document.documentElement.dataset.theme = resolveTheme(theme);
};
export const useTheme = (userTheme: ThemeId | null) => {
  const storedTheme = useMemo(getStoredTheme, []);

  const theme = userTheme ?? storedTheme;

  const resolvedTheme = useMemo(() => resolveTheme(theme), [theme]);

  useEffect(() => {
    applyTheme(theme);

    if (userTheme && localStorage.getItem(THEME_STORAGE_KEY) !== userTheme) {
      localStorage.setItem(THEME_STORAGE_KEY, userTheme);
    }
  }, [theme, userTheme]);

  useEffect(() => {
    if (theme === 'system') {
      const media = window.matchMedia('(prefers-color-scheme: dark)');

      const handleSystemThemeChange = () => {
        applyTheme('system');
      };

      media.addEventListener('change', handleSystemThemeChange);

      return () => {
        media.removeEventListener('change', handleSystemThemeChange);
      };
    }
    return undefined;
  }, [theme]);

  return {
    theme,
    resolvedTheme,
  };
};
// export const useTheme = (userTheme: ThemeId | '') => {
//   const [theme, setTheme] = useState<ThemeId>(getStoredTheme);

//   const resolvedTheme = useMemo(() => resolveTheme(theme), [theme]);

//   // const changeTheme = useCallback((nextTheme: ThemeId) => {
//   //   setTheme(nextTheme);
//   //   localStorage.setItem(THEME_STORAGE_KEY, nextTheme);
//   //   applyTheme(nextTheme);
//   // }, []);

//   useEffect(() => {
//     if (!userTheme || userTheme === theme) return;

//     setTheme(userTheme);
//     // applyTheme(userTheme);
//     localStorage.setItem(THEME_STORAGE_KEY, userTheme);
//   }, [userTheme, theme]);

//   useEffect(() => {
//     applyTheme(theme);
//   }, [theme]);

//   useEffect(() => {
//     if (theme !== 'system') return;

//     const media = window.matchMedia('(prefers-color-scheme: dark)');

//     const handleSystemThemeChange = () => {
//       applyTheme('system');
//     };

//     media.addEventListener('change', handleSystemThemeChange);

//     return () => {
//       media.removeEventListener('change', handleSystemThemeChange);
//     };
//   }, [theme]);

//   return {
//     theme,
//     resolvedTheme,
//     // changeTheme,
//   };
// };
